module.exports = __webpack_public_path__ + "static/media/workcom.37801f3c.jpg";